import { useTranslation } from 'react-i18next'

import { ROLE_TRANSLATION_ALIASES } from '../../../../constants/user'
import { TableCellText } from '../../TableCellText'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TableRoleCell({ unread, value, ...cellProps }) {
  const { t } = useTranslation()

  return value ? (
    <TableCellBase {...cellProps}>
      <TableCellText
        unread={unread}
        value={t(ROLE_TRANSLATION_ALIASES[value])}
      />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableRoleCell
